import PersonPage from './PersonPage';

export default PersonPage;